import { ArrowRight01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { IconAI } from "shared/components/ai/IconAI";
import { BOOM_HELP_COPY } from "../constants";

export const EmptyState = ({
  suggestions,
  onSelect,
  disabled
}: {
  suggestions: string[];
  onSelect: (question: string) => void;
  disabled: boolean;
}) => (
  <div className="flex h-full flex-col justify-center px-2 py-6">
    <div className="mb-6 flex flex-col items-center text-center">
      <IconAI bgSize={56} />
      <p className="mt-4 text-lg font-bold text-content-1000">
        {BOOM_HELP_COPY.title}
      </p>
      <p className="mt-1 text-sm font-medium text-content-300">
        {BOOM_HELP_COPY.empty}
      </p>
    </div>
    <div className="space-y-2">
      <p className="text-xs font-medium text-content-200">
        {BOOM_HELP_COPY.suggested}
      </p>
      {suggestions.map((question) => (
        <button
          key={question}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(question)}
          className="flex w-full items-center justify-between gap-3 rounded-lg border border-alpha-100 bg-white px-4 py-3 text-left text-sm font-medium text-content-1000 shadow-xs transition-colors hover:bg-alpha-40 disabled:cursor-not-allowed disabled:opacity-40"
        >
          {question}
          <HugeiconsIcon
            icon={ArrowRight01Icon}
            size={16}
            className="shrink-0 text-content-300"
          />
        </button>
      ))}
    </div>
  </div>
);
